const lokalizeTranslationsKeys = {
  savingsPlanDetails: 'savings_plan_details',
  inclSpread: 'incl_spread',
  currentValue: 'current_value',
  investedAmount: 'invested_amount',
  numberOfPurcahses: 'number_of_purchases',
  startedAt: 'started_at',
  nextPayment: 'next_payment_@tenant',
  frequency: 'frequency',
  paymentMethod: 'payment_method',
  orderId: 'order_id',
  copy: 'copy',
  pid: 'pid_@tenant',
  savingsPlansPidCopySuccessMessage: 'savings_plans_pid_copy_success_message',
  savingsPlanPidCopyFailedMessage: 'savings_plan_pid_copy_failed_message',
  cancelPlan: 'cancel_plan',
  resumePlan: 'resume_plan',
  goBack: 'go_back',
  cancelPlanConfirmationTitle: 'cancel_plan_confirmation_title',
  cancelPlanConfirmationDescription: 'cancel_plan_confirmation_description',
  cancelPlanInProgressConfirmationDescription:
    'cancel_plan_in_progress_confirmation_description',
  savingsPlanInProgressTitle: 'savings_plan_in_progress_title',
  savingsPlanInProgressDescription:
    'savings_plan_in_progress_description_@tenant',
  monthly: 'monthly',
  weekly: 'weekly',
  biweekly: 'biweekly',
  daily: 'daily',
  infoLabel: 'savings_plan_info_label_@tenant',
  emptyStateNoTransactions: 'empty_state_no_transactions',
  viewAllTransactions: 'view_all_transactions',
  savingsPlansListWeeklyNextOn: 'savings_plans_list_weekly_next_on',
  savingsPlansListBiweeklyNextOn: 'savings_plans_list_biweekly_next_on',
  savingsPlansListDailyNextOn: 'savings_plans_list_daily_next_on',
  savingsPlansListCreateButton: 'savings_plans_list_create_button',
  failed: 'failed',
  transactions: 'transactions',
  confirmed: 'confirmed',
  scheduled: 'scheduled',
  savingsPlansListTitleAll: 'savings_plans_list_title_all',
  savingsPlansListTitleAllPlural: 'savings_plans_list_title_all_plural',
  finished: 'finished',
  seeAll: 'see_all',
  createdAt: 'created_at',
  nextRecurrence: 'next_recurrence_@tenant',
};

export type SavingsPlanDetailsTranslations = {
  savingsPlanDetails: string;
  inclSpread: string;
  currentValue: string;
  savingsPlansListTitleAll: string;
  savingsPlansListTitleAllPlural: string;
  investedAmount: string;
  numberOfPurcahses: string;
  startedAt: string;
  nextPayment: string;
  frequency: string;
  paymentMethod: string;
  orderId: string;
  copy: string;
  savingsPlansPidCopySuccessMessage: string;
  savingsPlanPidCopyFailedMessage: string;
  pid: string;
  cancelPlan: string;
  resumePlan: string;
  goBack: string;
  cancelPlanConfirmationTitle: string;
  cancelPlanConfirmationDescription: string;
  cancelPlanInProgressConfirmationDescription: string;
  savingsPlanInProgressTitle: string;
  savingsPlanInProgressDescription: string;
  monthly: string;
  weekly: string;
  biweekly: string;
  daily: string;
  infoLabel: string;
  savingsPlansListTitleEmpty: string;
  savingsPlans: string;
  savingsPlansListSubtitle: string;
  savingsPlansListSubtitleEmpty: string;
  savingsPlansListActive: string;
  savingsPlansListCancelled: string;
  savingsPlansListEmpty: string;
  savingsPlansListMonthly: string;
  savingsPlansListMonthlyNextOn: string;
  savingsPlansListWeeklyNextOn: string;
  savingsPlansListBiweeklyNextOn: string;
  savingsPlansListDailyNextOn: string;
  savingsPlansListCreateButton: string;
  viewAllTransactions: string;
  latestTransactions: string;
  emptyStateNoTransactions: string;
  all: string;
  transactions: string;
  transactionsListEmpty: string;
  failed: string;
  confirmed: string;
  scheduled: string;
  finished: string;
  grams: string;
  seeAll: string;
  createdAt: string;
  nextRecurrence: string;
};

const getSavingsPlanDetailsTranslations = (
  t: (translationKey: keyof SavingsPlanDetailsTranslations) => string,
): SavingsPlanDetailsTranslations => {
  return Object.entries(lokalizeTranslationsKeys).reduce(
    (acc, [key, value]) => {
      acc[key as keyof SavingsPlanDetailsTranslations] = t(
        value as keyof SavingsPlanDetailsTranslations,
      );

      return acc;
    },
    {} as SavingsPlanDetailsTranslations,
  );
};

export { getSavingsPlanDetailsTranslations };
